import axios from 'axios';
import {
    getIsApiPending,
} from '../../../selectors/roaCarInsurance/quotation';
import {
    apiTransition,
    calculateCarMakesSuccess, collectCarModelsData
} from '../../../actions/roaCarInsurance/quotation';

export const carMakesService = (store, next, action) => {
    (async () => {
        if (!getIsApiPending(store.getState())) {
            store.dispatch(apiTransition.pending());
            try {
                const resp = await fetchCarMakes();
                store.dispatch(calculateCarMakesSuccess(resp.data));
                setTimeout(() => {
                    store.dispatch(collectCarModelsData())
                }, 0)
                if (resp.data.code) {
                    store.dispatch(apiTransition.failure(resp.data.code));
                } else {
                    store.dispatch(apiTransition.success());
                }
            } catch (e) {
                store.dispatch(apiTransition.failure(e.message));
            }
        }
    })();
    return next(action);
};

const fetchCarMakes = async () => {
    try {
        const url = '/om-api/roa-car-insurance/nigeria/car-make'
        return await axios.get(url);
    } catch (e) {
        throw e;
    }
};
